export default {
  isProd: process.env.GATSBY_NODE_ENV === 'prod',

  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Telia Engineering', // Navigation and Site Title
  siteTitleAlt: 'Telia Engineering & Data Science', // Alternative Site title for SEO
  siteUrl: 'https://engineering.telia.no', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteBanner: '/assets/banner.jpg', // Your image for og:image tag. You can find it in the /static folder
  defaultBg: '/assets/hero-bg.jpg', // default post background header
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteDescription: 'Creative engineers and data scientists building a world where you can belong anywhere\n', // Your site description
  author: 'Telia OSS Team', // Author for schemaORGJSONLD
  siteLogo: '/assets/logo.png', // Image for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@TeliaEng', // Twitter Username - Optional
  ogSiteName: 'Telia Engineering', // Facebook Site Name - Optional
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#9933FF',
  backgroundColor: '#726E6E',

  // Settings for typography.ts
  headerFontFamily: 'Bitter',
  bodyFontFamily: 'Telia Sans',
  baseFontSize: '18px',

  // Social media
  siteFBAppID: '',

  //
  Google_Tag_Manager_ID: 'GTM-TSW5',
  POST_PER_PAGE: 9,
};
